import { Link } from "react-router-dom";
import React from "react";
import {
  CookieScanner,
  CookieScannerProps,
} from "../../components/organisms/cookies/CookieScanner";
import { Para } from "../../components/typography/Para";
import { Paras } from "../../components/typography/Paras";
import { Routes } from "../../root/routes";

export const CookieScannerTab: React.FC<CookieScannerProps> = (props) => {
  const instructions = (
    <Paras>
      <Para />
      <Para>
        Add your website URL to get a list of your cookies. Designate a “Type” and “Data Recipient”
        for each cookie. <Link to={Routes.notices.publish}>Click here</Link> to access developer
        instructions for implementing your cookie settings with our consent management tool.
      </Para>
    </Paras>
  );

  return (
    <>
      <CookieScanner {...props} showDeveloperInstructions={false} instructions={instructions} />
    </>
  );
};
